import { render, staticRenderFns } from "./result_header.vue?vue&type=template&id=7aaebae4&"
import script from "./result_header.vue?vue&type=script&lang=js&"
export * from "./result_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports